/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Button_LabelInputs */

const en_cancel_button_label = /** @type {(inputs: Cancel_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const nl_cancel_button_label = /** @type {(inputs: Cancel_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Cancel_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const cancel_button_label = /** @type {((inputs?: Cancel_Button_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Button_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_cancel_button_label(inputs)
	return en_cancel_button_label(inputs)
});